import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { BookingCalculatedDetails, calculateBookingDetails } from 'src/api/bookingService';
import { BookingCalculationRequest } from 'src/api/bookingService/types';

export const useCalculateBookingDetails = () =>
    useMutation<BookingCalculatedDetails, AxiosError, BookingCalculationRequest>({
        mutationKey: ['calculateBookingDetails'],
        mutationFn: (bookingDetails) => calculateBookingDetails(bookingDetails),
    });
